<template>
  <el-dropdown
    ref="dropdownRef"
    position="bottom-end"
    :show-arrow="false"
    size="large"
    @command="handleDropdownCommand"
  >
    <span class="el-dropdown-link">
      <el-icon class="el-icon--right">
        <MoreFilled />
      </el-icon>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="add">新建文件夹</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { computed, ref, inject, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'
import { APP_HOME_MENU_KEY } from './util'

const { MoreFilled } = ElementPlusIcons

const props = defineProps<{
  menu?: any
}>()

const app = useHostAppInstance()

const appHomeMenu = inject(APP_HOME_MENU_KEY)

const dropdownRef = ref<any>()

function handleDropdownCommand(command: string) {
  switch (command) {
    case 'add':
      appHomeMenu.addChild({ isRoot: true })
      break
  }
}
</script>

<style lang="scss" scoped></style>
